var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15H3.41666V35H10.25V15Z",
    strokeWidth: 1.22686,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 13.3333C30.0518 13.3333 32.6589 14.3868 34.5812 16.2622C36.5034 18.1375 37.5833 20.6811 37.5833 23.3333V34.9999H30.75V23.3333C30.75 22.4492 30.39 21.6014 29.7493 20.9762C29.1085 20.3511 28.2395 19.9999 27.3333 19.9999C26.4272 19.9999 25.5581 20.3511 24.9174 20.9762C24.2766 21.6014 23.9167 22.4492 23.9167 23.3333V34.9999H17.0833V23.3333C17.0833 20.6811 18.1632 18.1375 20.0855 16.2622C22.0077 14.3868 24.6149 13.3333 27.3333 13.3333V13.3333Z",
    strokeWidth: 1.22686,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 10C8.7203 10 10.25 8.50766 10.25 6.66671C10.25 4.82576 8.7203 3.33337 6.83333 3.33337C4.94636 3.33337 3.41666 4.82576 3.41666 6.66671C3.41666 8.50766 4.94636 10 6.83333 10Z",
    strokeWidth: 1.22686,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e82847f73f14d2321986825528097a00.svg";
export { ForwardRef as ReactComponent };